module.exports = __webpack_public_path__ + "static/media/img_2.9aa5414e.png";